module.exports = __webpack_public_path__ + "img/qb_logo_black.17684c0a.svg";